import { render, staticRenderFns } from "./selecttag.vue?vue&type=template&id=1f1e5c36&scoped=true"
import script from "./selecttag.vue?vue&type=script&lang=ts"
export * from "./selecttag.vue?vue&type=script&lang=ts"
import style0 from "./selecttag.vue?vue&type=style&index=0&id=1f1e5c36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e5c36",
  null
  
)

export default component.exports